import React from 'react'
import { connect } from 'react-redux'
import context from '@/context'
import { actionCreators as identityActions } from '@/store/Identity'
import { localized } from '@/decorators/localized'
import { Form } from 'reactstrap'
import { ValidationBoundary } from '@/components/validation'
import { LoginBox } from '@/components/auth/loginBox'
import { Link } from 'react-router-dom'
import Icon from '@/components/Icon'
import history from '@/utils/history'

const getFailureText = ({ status, message }) => {
  switch (status) {
    case 502: return 'Common.ServiceUnavailable'
    default: return message || 'Security.LoginFailed'
  }
}

@localized()
class LoginPageComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      userName: '',
      password: '',
      failed: false,
      loading: false,
      showTwoFactor: false,
      twoFactorCode: '',
      usePreferredProviderOnly: true,
      preferredProvider: null
    }
  }
  prepareLoginDto = () => {
    const { userName, password, showTwoFactor, twoFactorCode, usePreferredProviderOnly } = this.state
    return {
      userName,
      password,
      twoFactorCode: showTwoFactor ? twoFactorCode : '',
      usePreferredProviderOnly
    }
  }
  signIn = () => {
    if (this.state.userName && this.state.password) {
      this.setState(
        { loading: true },
        () => {
          context.api.auth.login(this.prepareLoginDto())
            .then(result => {
              if (result.isOk === true) {
                this.props.loadUser()
              } else {
                this.setState({ loading: false })
                if (result.isTwoFactorAuthenticationRequired) {
                  this.setState({
                    failed: this.state.showTwoFactor ? { message: 'Security.InvalidTwoFactorCode' } : false,
                    preferredProvider: result.preferredTwoFactorProvider,
                    showTwoFactor: true
                  })
                } else {
                  if (result.isPasswordResetRequired) {
                    const url = `/login/reset?email=${encodeURIComponent(result.email)}&token=${encodeURIComponent(result.token)}&reason=${result.resetPasswordReason}`
                    history.push(url)
                  }
                  this.setState({ failed: false })
                }
              }
            })
            .catch(e => {
              this.setState({
                loading: false,
                failed: { status: e.response.status, message: ((e.response.data || {}).error || {}).message }
              })
            })
        }
      )
    }
  }
  handleLoginClick = (e) => {
    e.preventDefault()
    this.signIn()
  }
  goBack = (e) => {
    e.preventDefault()
    this.setState({
      twoFactorCode: '',
      showTwoFactor: false,
      failed: false
    })
  }
  resendCode = () => {
    this.setState({
      showTwoFactor: false,
      twoFactorCode: '',
      failed: false,
      usePreferredProviderOnly: false,
      preferredProvider: null
    }, () => this.signIn())
  }
  onUsernameChange = (e) => { this.setState({ userName: e.target.value }) }
  onPasswordChange = (e) => { this.setState({ password: e.target.value }) }
  onTwoFactorCodeChange = (e) => { this.setState({ twoFactorCode: e.target.value }) }
  render () {
    const { localize } = this.props
    const { loading, failed, userName, password, twoFactorCode, showTwoFactor } = this.state
    return (
      <LoginBox title='Security.LoginTitle'>
        <Form>
          <ValidationBoundary>
            {!showTwoFactor && <React.Fragment>
              <div className='form-group'>
                <label htmlFor='UserName'>{localize('Security.UserName')}</label>
                <input
                  value={userName} onChange={this.onUsernameChange} disabled={loading}
                  className='form-control' placeholder={localize('Security.UserName')} autoFocus
                  id='UserName' name='UserName' />
              </div>
              <div className='form-group'>
                <label htmlFor='Password'>{localize('Security.Password')}</label>
                <input
                  value={password} onChange={this.onPasswordChange} disabled={loading}
                  type='password' className='form-control' placeholder={localize('Security.Password')} autoComplete='off'
                  id='Password' name='Password' />
              </div>
            </React.Fragment>}
            {showTwoFactor && <React.Fragment>
              <p>{localize('Security.TwoFactorAuthenticationRequired')}</p>
              <div className='form-group'>
                <label htmlFor='TwoFactorCode'>{localize('Security.TwoFactorCode')}</label>
                <input
                  value={twoFactorCode} onChange={this.onTwoFactorCodeChange} disabled={loading}
                  className='form-control' placeholder={localize('Security.TwoFactorCode')} autoFocus
                  id='TwoFactorCode' name='TwoFactorCode' />
              </div>
            </React.Fragment>}
            {failed && <div className='alert alert-danger'>
              <div className='danger validation-summary-errors'>
                {localize(getFailureText(failed))}
              </div>
            </div>}
            <div className='form-group d-flex justify-content-between'>
              <button disabled={loading} className='btn btn-primary' onClick={this.handleLoginClick}>
                <Icon name={loading ? 'loader bx-spin' : 'log-in'} /> &nbsp; {localize('Security.LoginButton')}
              </button>
              {showTwoFactor &&
                <button className='btn btn-primary' onClick={this.resendCode}>
                  {localize('Security.ResendCode')}
                </button>
              }
            </div>
          </ValidationBoundary>
          {!showTwoFactor && <Link to='/login/forgot'>{localize('Security.ForgotPassword')}</Link>}
          {showTwoFactor && <React.Fragment>
            <a href='' onClick={this.goBack}>{localize('Common.GoToLoginButton')}</a>
          </React.Fragment>}
        </Form>
      </LoginBox>
    )
  }
}

const mapDispatchToProps = {
  loadUser: identityActions.loadUser
}

const LoginPage = connect(null, mapDispatchToProps)(LoginPageComponent)
export { LoginPage }



// WEBPACK FOOTER //
// ./src/components/auth/loginPage.js